// extracted by mini-css-extract-plugin
export default {"pageHeading":"pageHeading_pageHeading__n6PLd"};